// TODO: delete "@ts-nocheck" after typing this file
// @ts-nocheck

import { sendToGa4Dictionary } from "@/helpers";
import { sendYMEvent } from "../services/YandexMetrika/YandexMetrika";
import { IYMPropsParams } from "../services/YandexMetrika/interfaces";
import {
  IFrisbuyWidgetPost,
  IPostLinkInList,
  IPostMedia,
} from "@/gallery/interfaces";
import { sendFrisbuyAnalyticsEvent } from "../services/FrisbuyAnalytics/FrisbuyAnalytics";
import { IFrisbuyAnalyticsPropsParams } from "../services/FrisbuyAnalytics/interfaces";

export function getStock(
  postList: Array<IFrisbuyWidgetPost>,
  embedId: string,
  skuId: string
) {
  if (!postList || !embedId || !skuId) {
    return null;
  }

  const media: Array<IPostMedia> = [];
  const linkList: Array<IPostLinkInList> = [];

  let isAvailable = null;

  postList.forEach((post) => {
    if (post && post.media && post.media.length > 0) {
      media.push(...post.media);
    }
  });

  media.forEach((media) => {
    linkList.push(...media.linkList);
  });

  for (let i = 0; i < linkList.length; i++) {
    if (linkList[i].sku?.offerId === skuId) {
      isAvailable = linkList[i].sku?.isAvailable;

      break;
    }
  }

  return isAvailable;
}

export default {
  data() {
    return {
      labelItemPosition: [],
      categoryPostfix: "Widget",
      noSendEvent: false,
    };
  },

  methods: {
    sendAnalyticEvent(
      action,
      label: string | object,
      sendToClient = true,
      isNonInteraction = false
    ) {
      const { noSendEvent, sendGAEvent } = this;

      if (noSendEvent) return;

      sendGAEvent(action, label, sendToClient, isNonInteraction);

      const ymParams: IYMPropsParams = {
        embedId: this.settings.embedId,
        galleryId: this.settings.galleryId,
        skuId: this.settings.skuId,
        skuGroupId: this.settings.groupId,
        categoryId: this.settings.categoryId,
        tagCode: this.settings.tagCode,
        frUId: this.settings.frisbuyUID,
      };

      // TODO: check `label` on correct data
      if (typeof label === "object") {
        Object.assign(ymParams, label);

        // console.log("label is object", label);
      } else {
        // console.log("label is string", label);
      }

      sendYMEvent(
        this.settings.analytics.ym.clientCounterId,
        action,
        ymParams, // label
        this.categoryPostfix,
        // yandexAdditional: this.yandexAdditional,
        this.settings.verbose
      );

      // [START] Frisbuy Analytics
      const frisbuyParams: IFrisbuyAnalyticsPropsParams = {
        srcDomain: this.settings.srcDomain,

        embedId: this.settings.embedId,
        galleryId: this.settings.galleryId,
        skuId: this.settings.skuId,
        skuGroupId: this.settings.groupId,
        categoryId: this.settings.categoryId,
        tagCode: this.settings.tagCode,
        frUId: this.settings.frisbuyUID,
      };

      // TODO: check `label` on correct data
      if (typeof label === "object") {
        Object.assign(frisbuyParams, label);
      }

      sendFrisbuyAnalyticsEvent(action, frisbuyParams);
      // [END] Frisbuy Analytics
    },

    sendGAEvent(action, label, sendToClient, isNonInteraction) {
      const originalAction = action;
      const data = this;
      const {
        settings,
        defaultAction,
        componentAction,
        defaultLabel,
        componentLabel,
        categoryPostfix,
        category,
      } = this;
      const { analytics } = settings;

      const labelString =
        (componentLabel && componentLabel(label)) || defaultLabel(label);

      action =
        (componentAction && componentAction({ action, label })) ||
        defaultAction(action);

      if (settings.analytics.ga.sendToGa) {
        if (settings.verbose) {
          console.log(
            `%cSend event: %c${category} %c${action} %c${labelString}`,
            "color: red; font-weight: bold",
            "color: blue",
            "color: green",
            "color: darkcyan"
          );
        }

        // GA3
        // if (window.frisbuyGa) {
        //   if (isNonInteraction) {
        //     window.frisbuyGa(
        //       'frisbuyGa.send',
        //       'event',
        //       category,
        //       action,
        //       labelString,
        //       {
        //         nonInteraction: true
        //       }
        //     );
        //   } else {
        //     window.frisbuyGa(
        //       'frisbuyGa.send',
        //       'event',
        //       category,
        //       action,
        //       labelString
        //     );
        //   }
        // }

        // GA4
        if (window.frisbuyGa4) {
          sendToGa4Dictionary(originalAction, data, label, true);
        }
      }

      if (!sendToClient) return;

      if (analytics.gtm && analytics.gtm.eventName) {
        const { gtm } = analytics;
        const gtmPayload = Object.assign(gtm.static || {}, {
          event: gtm.eventName,
          [gtm.eventCategory]: `Frisbuy_${categoryPostfix}`,
          [gtm.eventAction]: action,
          [gtm.eventLabel]: labelString,
          [gtm.eventNonInteractive]: isNonInteraction,
        });

        window.frisbuyGTM(gtmPayload);
      }

      if (analytics.ga.sendToClient) {
        if (settings.verbose) {
          console.log(
            `${window["GoogleAnalyticsObject"]}('send', 'event', 'Frisbuy_Gallery', '${action}', '${labelString}')`
          );
        }

        /* [HACK]
          After Google did update GA3 -> GA4
          our GA3-funcs become send events to GA4
          along with GA4-funcs.

          Need refactor our analytic to remove
          old `frisbuyGa` or new `frisbuyGa4`
        */

        // if (window.frisbuyGa) {
        //   if (isNonInteraction) {
        //     window.frisbuyGa(
        //       `send`,
        //       'event',
        //       'Frisbuy_Gallery',
        //       action,
        //       labelString,
        //       {
        //         nonInteraction: true
        //       }
        //     );
        //   } else {
        //     window.frisbuyGa(
        //       `send`,
        //       'event',
        //       'Frisbuy_Gallery',
        //       action,
        //       labelString
        //     );
        //   }
        // }

        // debugger;
        if (window.frisbuyGa4) {
          sendToGa4Dictionary(originalAction, data, label);
        }
      }
    },

    defaultAction(action) {
      const { settings } = this;

      return `${action}_embedID${settings.embedId}`;
    },

    defaultLabel(label) {
      const { labelItemPosition } = this;

      return typeof label === "object"
        ? labelItemPosition.reduce((labelString, currentLabelItem) => {
            if (!Object.hasOwn(label, currentLabelItem)) return labelString;

            return (
              (labelString ? `${labelString}_` : labelString) +
              currentLabelItem +
              label[currentLabelItem]
            );
          }, "")
        : label;
    },
  },
};
